//import { Action } from "redux";
import { UserGroupAssociatedArea } from "../../models/user-groups/UserGroup";
import { ofType } from "redux-observable";
import { mergeMap, map, catchError } from "rxjs/operators";
import { APP_CONFIG } from "../../config/GeneralConfig";
import { ajax } from "rxjs/ajax";
import { Observable, of } from 'rxjs';
import { eventNotificationShow } from "../common/EventNotificationActions";
import { EVENT_NOTIFICATION_TYPE } from "../../helpers/EventNotificationType";
import { ApiReturnType, ApiFetchError } from "../../models/common/ApiReturnType";
import { View } from "../../models/common/ViewSettings";

export interface FetchUserGroupsAreasAction {
    type: typeof FETCH_USER_GROUPS_AREAS
}
export interface FetchUserGroupsAreasSuccessAction {
    type: typeof FETCH_USER_GROUPS_AREAS_SUCCESS
    areas: ApiReturnType< UserGroupAssociatedArea[] >
}
export interface FetchUserGroupsAreasErrorAction {
    type: typeof FETCH_USER_GROUPS_AREAS_ERROR
    error: Error
}

export type UserGroupsAreasActionTypes = FetchUserGroupsAreasAction
    | FetchUserGroupsAreasSuccessAction
    | FetchUserGroupsAreasErrorAction
    | FetchUserGroupAreaViewActionTypes
/*| HandlePermissionChangeActionTypes*/

/**
 * fetching the associated areas, which the user groups can be related to. normally one user group is related to one area
 */
export const FETCH_USER_GROUPS_AREAS = "FETCH_USER_GROUPS_AREAS";
export const FETCH_USER_GROUPS_AREAS_SUCCESS = "FETCH_USER_GROUPS_AREAS_SUCCESS";
export const FETCH_USER_GROUPS_AREAS_ERROR = "FETCH_USER_GROUPS_AREAS_ERROR";


export const fetchUserGroupsAreas = (): FetchUserGroupsAreasAction => ({ type: FETCH_USER_GROUPS_AREAS });
export const fetchUserGroupsAreasSuccess = ( areas: ApiReturnType< UserGroupAssociatedArea[] > ): FetchUserGroupsAreasSuccessAction => ({ type: FETCH_USER_GROUPS_AREAS_SUCCESS, areas });
export const fetchUserGroupsAreasError = ( error: Error): FetchUserGroupsAreasErrorAction => ({ type: FETCH_USER_GROUPS_AREAS_ERROR, error });

export const fetchUserGroupsAreasEpic = ( action$: Observable< FetchUserGroupsAreasAction > ) =>
    action$.pipe(
        ofType( FETCH_USER_GROUPS_AREAS ),
        mergeMap( action => {
            // console.log( store$ );
 
             const path = `${ APP_CONFIG.baseWeb }system/user_groups/areas`;
 
             return ajax( APP_CONFIG.getRequestObject( path ) ).pipe(
                 map( response => fetchUserGroupsAreasSuccess( response.response as ApiReturnType< UserGroupAssociatedArea[] > ) ),
                 catchError( error =>
                     of(
                         fetchUserGroupsAreasError( error ),
                         eventNotificationShow(
                             EVENT_NOTIFICATION_TYPE.customAjaxError,
                             "Bereiche konnten nicht geladen werden!"
                         )
                     )
                 )
             );
         })
    );

/**
 * FETCH VIEWS AND PRIVILEGES
 */
interface FetchUserGroupViewsBaseArgs {
    userGroupId: number
    areaId: number
}
export interface FetchUserGroupAreaViewsAction extends FetchUserGroupViewsBaseArgs {
    type: typeof FETCH_USER_GROUPS_AREAS_VIEWS
}
export interface FetchUserGroupAreaViewsSuccessAction extends FetchUserGroupViewsBaseArgs {
    type: typeof FETCH_USER_GROUPS_AREAS_VIEWS_SUCCESS
    payload: View[]
}
export type FetchUserGroupAreaViewErrorAction = ApiFetchError< typeof FETCH_USER_GROUPS_AREAS_VIEWS_ERROR >
type FetchUserGroupAreaViewActionTypes = FetchUserGroupAreaViewErrorAction | FetchUserGroupAreaViewsAction | FetchUserGroupAreaViewsSuccessAction

export const FETCH_USER_GROUPS_AREAS_VIEWS = "FETCH_USER_GROUPS_AREAS_VIEWS";
export const FETCH_USER_GROUPS_AREAS_VIEWS_SUCCESS = "FETCH_USER_GROUPS_AREAS_VIEWS_SUCCESS";
export const FETCH_USER_GROUPS_AREAS_VIEWS_ERROR = "FETCH_USER_GROUPS_AREAS_VIEWS_ERROR";


export const fetchUserGroupAreaViews = ( areaId: number, userGroupId: number = 0 ): FetchUserGroupAreaViewsAction => 
    ({ type: FETCH_USER_GROUPS_AREAS_VIEWS, areaId, userGroupId });
export const fetchUserGroupAreaViewsSuccess = ( areaId: number, userGroupId: number = 0, payload: View[] ): FetchUserGroupAreaViewsSuccessAction =>
    ({ type: FETCH_USER_GROUPS_AREAS_VIEWS_SUCCESS, areaId, userGroupId, payload });
export const fetchUserGroupAreaViewsError = ( error: Error ): FetchUserGroupAreaViewErrorAction => ({ type: FETCH_USER_GROUPS_AREAS_VIEWS_ERROR, error });

export const fetchUserGroupAreaViewsEpic = ( action$: Observable< FetchUserGroupAreaViewsAction > ) =>
    action$.pipe(
        ofType( FETCH_USER_GROUPS_AREAS_VIEWS ),
        mergeMap( action => {
            const path = `${APP_CONFIG.baseWeb}system/user_groups/${action.userGroupId}/areas/${action.areaId}/views`;
            return ajax( APP_CONFIG.getRequestObject( path) ).pipe(
                map( response => fetchUserGroupAreaViewsSuccess(
                    action.areaId,
                    action.userGroupId,
                    response.response as View[]
                ) ),
                catchError( error => of(
                    fetchUserGroupAreaViewsError( error ),
                    eventNotificationShow(
                        EVENT_NOTIFICATION_TYPE.ajaxFailure,
                        "Unterseiten des gewählten Bereiches konnten nicht geladen werden!"
                    )
                ))    
            );
        } )
    );

/**
 * handle permission change
 */
/*interface HandlePermissionChangeBaseAction {
    areaId: number
    privilegeId: number
    userGroupId: number
}
export interface HandlePermissionChangeAction extends HandlePermissionChangeBaseAction {
    type: typeof HANDLE_PERMISSION_CHANGE
}
export interface HandlePermissionChangeSuccessAction extends HandlePermissionChangeBaseAction {
    type: typeof HANDLE_PERMISSION_CHANGE_SUCCESS
    permitted: boolean  
}
export interface HandlePermissionChangeErrorAction {
    type: typeof HANDLE_PERMISSION_CHANGE_ERROR
    error: Error
}
export type HandlePermissionChangeActionTypes = HandlePermissionChangeAction | HandlePermissionChangeSuccessAction | HandlePermissionChangeErrorAction

 export const HANDLE_PERMISSION_CHANGE = "HANDLE_PERMISSION_CHANGE";
 export const HANDLE_PERMISSION_CHANGE_SUCCESS = "HANDLE_PERMISSION_CHANGE_SUCCESS";
 export const HANDLE_PERMISSION_CHANGE_ERROR = "HANDLE_PERMISSION_CHANGE_ERROR";

 export const handlePermissionChange = ( areaId: number, privilegeId: number, userGroupId: number = 0 ): HandlePermissionChangeAction => 
    ({ type: HANDLE_PERMISSION_CHANGE, areaId, privilegeId, userGroupId });
export const handlePermissionChangeSuccess = ( areaId: number, privilegeId: number, userGroupId: number = 0, permitted: boolean = false ) => 
    ({ type: HANDLE_PERMISSION_CHANGE_SUCCESS, areaId, privilegeId, userGroupId, permitted });
export const handlePermissionChangeError = ( error: Error ) => ({ type: HANDLE_PERMISSION_CHANGE_ERROR, error });*/